import React from 'react'
import classnames from 'classnames'

import {
  Modal,
  ModalContent,
  ModalOverlay
} from 'src/shared/components/common/modal'
import { t } from 'src/translations'
import { Button } from 'shared/components/common/button'
import { ScreenWidth, useIsMobile } from 'src/shared/js/utils/WindowContext'

type DeleteAddressConfirmationProps = {
  onConfirm: () => void
  onCancel: () => void
  isOpen: boolean
  onClose: () => void
  address: string
}

export const DeleteAddressConfirmation = ({
  onConfirm,
  onCancel,
  isOpen,
  onClose,
  address
}: DeleteAddressConfirmationProps) => {
  const isMobile = useIsMobile(ScreenWidth.SMALL)
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      testId={'account-address-modal'}
      preventOverlayClose={true}
    >
      <ModalOverlay />
      <ModalContent
        contentClassName={classnames(
          'modalContentV2 deleteAddressConfirmationModalContent',
          isMobile && 'bottomDrawerMobile mobile'
        )}
      >
        <div className='header' data-testid='DeleteAddressConfirmation'>
          <div className='text'>
            <div className='headerText'>
              {t('delete-address.delete-address')}
            </div>
            <div className='message'>
              <p>{t('delete-address.are-you-sure')}</p>
              <p className='address'>{address}</p>
            </div>
          </div>
        </div>
        <div className={classnames('body', isMobile && 'mobile')}>
          <Button
            className='cancelButton'
            onClick={onCancel}
            testId='delete-address-cancel'
          >
            {t('delete-address.cancel')}
          </Button>
          <Button
            className='confirmButton'
            onClick={onConfirm}
            testId='delete-address-confirm'
          >
            {t('delete-address.delete')}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  )
}
